import { Rect } from '../../scorecard-mi2/chart/util';

export const rect: Rect = { width: '100%', height: 300, top: 20 };
